import React from 'react';
import './Input.scss';

interface Props {
  id: string,
  className?: string;
  type: string,
  name?: string;
  placeholder?: string;
  click?: () => void;
}

const Input: React.FC<Props> = ({ id, className, type, name, placeholder }) => {
  const classArray = () => {
    return className ? className : "input"
  }
  return <input className={classArray()} id={id} type={type} name={name} placeholder={placeholder} />;
};

export default Input;
